import { request } from "../../httpClient";

export const getUserRequest = async (id) => {
  const res = await request({
    path: `user/protected/user?id=${id}`,
  });
  return res;
};
